<template>
  <main class="col-md-9 col-xl-8 offset-xl-2 pt-4" v-if="user">
    <ci-modal-image-delete v-if="showModal" @modal-image-delete:close="showModal = false" @modal-image-delete:delete="deleteImage" />
    <ci-modal-change-password v-if="changePasswordModal" @modal-change-password:close="changePasswordModal = false"  @modal-change-password:change="changePassword" />
    <h1 class="mb-0">Profil</h1>

    <hr>
    <div class="row">
      <div class="col-4 offset-4">
        <ci-image v-if="user.image" :image="user.image" deletable rounded @image:delete="onImageDelete" />
        <ci-dropzone v-else @dropzone:files-selected="onFilesSelected" />
      </div>
    </div>

    <label class="mt-3" :for="`${_uid}-firstname`">Benutzername</label>
    <input
      type="text"
      :class="getInputClass('username')"
      placeholder="Benutzername eingeben…"
      :id="`${_uid}-username`"
      v-model="user.username">

    <label v-if="!user.id" class="mt-3" :for="`${_uid}-password`">Passwort</label>
    <input
      v-if="!user.id"
      :class="getInputClass('password')"
      type="password"
      class="form-control"
      placeholder="Passwort eingeben…"
      :id="`${_uid}-password`"
      v-model="password">

    <label class="mt-3" :for="`${_uid}-email`">E-Mail</label>
    <input
      type="email"
      :class="getInputClass('email')"
      placeholder="Passwort eingeben…"
      :id="`${_uid}-email`"
      v-model="user.email">

    <label class="mt-3" :for="`${_uid}-firstname`">Vorname</label>
    <input
      type="text"
      :class="getInputClass('firstname')"
      placeholder="Vorname eingeben…"
      :id="`${_uid}-firstname`"
      v-model="user.firstname">
    <label class="mt-3" :for="`${_uid}-lastname`">Nachname</label>
    <input
      type="text"
      :class="getInputClass('lastname')"
      placeholder="Nachname eingeben…"
      :id="`${_uid}-lastname`"
      v-model="user.lastname">
    <label class="mt-3" :for="`${_uid}-position`">Titel</label>
    <input
      type="text"
      :class="getInputClass('position')"
      placeholder="Titel eingeben…"
      :id="`${_uid}-position`"
      v-model="user.position">

    <label class="mt-3" :for="`${_uid}-description`">Beschreibung</label>
    <textarea :class="getInputClass('description')" :id="`${_uid}-description`" rows="3" v-model="user.description">
    </textarea>
    <button class="mt-2 mr-2 btn btn-warning" @click="onChangePassword" v-if="user.id">Passwort ändern</button>
    <button class="mt-2 btn btn-primary" @click="saveProfile">Speichern</button>

  </main>
</template>

<script>
// components
import Dropzone from '@/components/Dropzone.vue';
import ProfileIcon from '@/components/ProfileIcon.vue';
import ModalChangePassword from '@/components/modals/ModalChangePassword.vue';
import ModalImageDelete from '@/components/modals/ModalImageDelete.vue';

// models
import UserModel from '@/models/UserModel';
import ImageModel from '@/models/ImageModel';

// mixins
import fieldValidation from '@/mixins/fieldValidation';

// elements
import ElementImage from '@/elements/Image.vue';
import FileService from '@/services/FileService';
import UserService from '@/services/UserService';

export default {
  name: 'UserCreateEdit',

  mixins: [fieldValidation],

  components: {
    'ci-dropzone': Dropzone,
    'ci-image': ElementImage,
    'ci-modal-change-password': ModalChangePassword,
    'ci-modal-image-delete': ModalImageDelete,
    'ci-profile-icon': ProfileIcon,
  },

  props: {
    id: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      changePasswordModal: false,
      user: null,
      password: null,
      ready: false,
      showModal: false,
    };
  },

  created() {
    if (this.id) {
      UserService.findOne(this.id)
        .then((response) => {
          this.user = new UserModel(response);
        });
    } else {
      this.user = new UserModel();
    }
  },

  watch: {
    user: {
      handler() {
        this.resetValidation();
      },
      deep: true,
    },
  },

  methods: {
    changePassword(payload) {
      UserService.changePassword(this.user.id, payload.password);
    },

    deleteImage() {
      this.user.set('image', null);
      this.user.set('image_id', null);
      this.showModal = false;
    },

    onChangePassword() {
      this.changePasswordModal = true;
    },

    onFilesSelected(files) {
      FileService.uploadImages(files)
        .then((response) => {
          this.user.set('image_id', response[0].id);
          this.user.set('image', new ImageModel(response[0]));
        });
    },

    onImageDelete() {
      this.showModal = true;
    },

    saveProfile() {
      if (this.id) {
        UserService.update(this.user.id, {
          id: this.user.id,
          email: this.user.email,
          username: this.user.username,
          firstname: this.user.firstname,
          lastname: this.user.lastname,
          title: this.user.title,
          description: this.user.description,
          image_id: this.user.image ? this.user.image.id : null,
          position: this.user.position ? this.user.position : null,
        })
          .catch((err) => {
            this.setInvalidFields(err);
          });
      } else {
        Object.assign(this.user, {
          password: this.password,
        });
        UserService.create(this.user)
          .catch((err) => {
            this.setInvalidFields(err);
          });
      }
    },
  },
};
</script>
